import {
  Injectable,
  ApplicationRef,
  Injector,
  ComponentRef,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { ScaffoldDialogFrameComponent } from './scaffold-dialog-frame/scaffold-dialog-frame.component';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ScaffoldDialogService {
  private modalComponentRefs: ComponentRef<ScaffoldDialogFrameComponent>[] = [];

  constructor(
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  defaultConfig: any = {
    hasBackdrop: true,
    context: null,
    closeOnBackdropClick: true,
    closeOnEsc: true,
    showCloseButton: false,
  };

  open(component: Type<any>, config?: any) {
    if (!config) {
      config = this.defaultConfig;
    } else {
      config = { ...this.defaultConfig, ...config };
    }
    document.body.classList.add('modal-open');
    const rootViewContainerRef =
      this.appRef.components[0].injector.get(ViewContainerRef);
    const modalComponentRef = rootViewContainerRef.createComponent(
      ScaffoldDialogFrameComponent,
      { injector: this.injector }
    );
    modalComponentRef.instance.settings = config;
    modalComponentRef.changeDetectorRef.detectChanges();
    const scaffoldDialogRef = new ScaffoldDialogRef(modalComponentRef, this);
    scaffoldDialogRef.settings = config;
    const modalContentViewContainerRef =
      modalComponentRef.instance.viewContainerRef;
    const injector = Injector.create({
      providers: [{ provide: ScaffoldDialogRef, useValue: scaffoldDialogRef }],
      parent: this.injector,
    });
    const modalContentComponentRef =
      modalContentViewContainerRef.createComponent(component, {
        injector: injector,
      });
    if (config.context) {
      for (const key in config.context) {
        if (Object.prototype.hasOwnProperty.call(config.context, key)) {
          const value = config.context[key];
          (modalContentComponentRef.instance as any)[key] = value;
          try {
            if (typeof modalContentComponentRef.setInput === 'function') {
              modalContentComponentRef.setInput(key, value);
            }
          } catch {}
        }
      }
    }
    scaffoldDialogRef.contentComponentRef = modalContentComponentRef;
    modalContentComponentRef.changeDetectorRef.detectChanges();
    modalComponentRef.changeDetectorRef.detectChanges();
    modalComponentRef.instance.closed.subscribe(() => {
      this.close(modalComponentRef);
    });
    this.modalComponentRefs.push(modalComponentRef);
    return scaffoldDialogRef;
  }

  close(modalComponentRef: ComponentRef<ScaffoldDialogFrameComponent>): void {
    this.appRef.detachView(modalComponentRef.hostView);
    this.modalComponentRefs = this.modalComponentRefs.filter(
      ref => ref !== modalComponentRef
    );
    modalComponentRef.destroy();
    if (this.findBackdropModalCount() === 0) {
      document.body.classList.remove('modal-open');
    }
  }

  findBackdropModalCount(): number {
    return this.modalComponentRefs.filter(
      ref => ref.instance.settings.hasBackdrop
    ).length;
  }
}

export class ScaffoldDialogRef {
  private _closed = false;

  constructor(
    private modalComponentRef: ComponentRef<ScaffoldDialogFrameComponent>,
    private scaffoldDialogService: ScaffoldDialogService
  ) {
    this.onClose = new Subject<any>();
    this.modalComponentRef.instance.closed.subscribe(() => {
      this.close(null);
    });
  }
  public result: any = null;
  settings: any;
  contentComponentRef?: ComponentRef<any>;

  get componentInstance(): any {
    return this.contentComponentRef?.instance;
  }

  close(result?: any): void {
    if (this._closed) return;
    this._closed = true;
    this.onClose.next(this.result ?? result);
    this.onClose.complete();
    this.scaffoldDialogService.close(this.modalComponentRef);
  }
  onClose: Subject<any>;
}
